import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const LegalLayout = ({ title, lastUpdated, intro, sections, testId }) => {
  return (
    <div className="overflow-hidden" data-testid={testId}>
      {/* Hero */}
      <section className="py-24 md:py-28 bg-[#FAFAF8] relative">
        <div className="absolute inset-0 grain-overlay" />
        <div className="container-custom relative z-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[#2D7D7B] hover:text-[#1F5A58] mb-8 transition-colors"
            data-testid="legal-back-home"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
          <div className="max-w-3xl">
            <span className="text-sm font-bold uppercase tracking-widest text-[#C9A962] mb-4 block">
              Legal
            </span>
            <h1 className="font-serif text-4xl md:text-5xl font-bold text-[#1B365D] mb-4">
              {title}
            </h1>
            <p className="text-sm text-[#1B365D]/60">Last updated: {lastUpdated}</p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-20 bg-white">
        <div className="container-custom">
          <div className="max-w-3xl">
            {intro && (
              <p className="text-lg text-[#1B365D]/75 leading-relaxed mb-10">{intro}</p>
            )}

            <div className="space-y-10">
              {sections.map((section, i) => (
                <div key={i}>
                  <h2 className="font-serif text-2xl font-bold text-[#1B365D] mb-4">
                    {`${i + 1}. ${section.heading}`}
                  </h2>
                  {section.body?.map((para, j) => (
                    <p key={j} className="text-[#1B365D]/75 leading-relaxed mb-4">
                      {para}
                    </p>
                  ))}
                  {section.items && (
                    <ul className="space-y-2 mb-4">
                      {section.items.map((item, k) => (
                        <li key={k} className="flex items-start gap-3 text-[#1B365D]/75">
                          <span className="w-1.5 h-1.5 rounded-full bg-[#C9A962] mt-2.5 flex-shrink-0" />
                          <span className="leading-relaxed">{item}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>

            <div className="mt-12 p-6 rounded-2xl bg-[#F5F5F0] border border-[#C9A962]/20">
              <p className="text-sm text-[#1B365D]/70 leading-relaxed">
                This document is provided for general informational purposes and does not constitute
                legal advice. Please consult a qualified attorney to ensure it meets your specific
                legal requirements.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
